import { FetchError } from 'ofetch'
import type { H3Error } from 'h3'

export const isH3Error = (e: unknown): e is H3Error<{ message: string; url: string; statusCode: number }> => {
  return typeof e === 'object' && e instanceof FetchError
}
